import { ReferralPageAction, ReferralPageActionState } from 'placement/reducers/referralPage';
import { ReferralList } from './ReferralList';
import { ReferralListDetailBar } from './ReferralListDetailBar';
import { NavigationBar } from './NavigationBar';
import { ReferralDetailModal } from './ReferralDetailModal';
import {PlacementType, ReferralConsideration, ServiceLocationType, ServiceType} from 'placement/const';
import { MatchOffersModal } from './MatchOffersModal';
import React from 'react';
import { ProviderSelectionModal } from 'providerapp/component/ProviderSelectionModal';
import { useHistory } from 'react-router';
import { ApplicationRootUrl } from 'common/component/ApplicationRootContext';

type PlacementPageProps = {
    appState: ReferralPageActionState;
    dispatch: (action: ReferralPageAction) => void;
};

export function PlacementPage({ appState, dispatch }: PlacementPageProps) {
    const { page,
          filter,
          sortBy,
          pagination,
          currentCursor,
          showDetailModal,
          selectedReferral,
          selectedOfferGuids,
          showMatchModal,
          referrals,
          offerConversationOnly,
        } = appState;

    const visibleServiceTypes = Object.values(ServiceType).filter(
        (serviceType) =>
            serviceType !== ServiceType.Compass_Psychotherapy &&
            serviceType !== ServiceType.Psychotherapy,
    );
    const filterOption = {
        escalationLevels: ['1', '2', '3', '4'],
        referralConsiderations: Object.values(ReferralConsideration),
        scopeOfService: Object.values(PlacementType),
        serviceType: visibleServiceTypes,
        serviceLocationTypes: Object.values(ServiceLocationType)
    };

    const [showProviderSelectionModal, setShowProviderSelectionModal] = React.useState(false);
    const history = useHistory();


    return (
        <div className=''>
            <NavigationBar
                openViewAsProviderSelectionModal={() => setShowProviderSelectionModal(true)}
                filterOption={filterOption}
                initFilterValue={filter}
                page={page}
                dispatch={dispatch} />
            <div className='px-5 py-10'>
                <ReferralListDetailBar
                    dispatch={dispatch}
                    pagination={pagination}
                    filter={filter}
                    selectedOfferGuids={selectedOfferGuids}
                    offerConversationOnly={offerConversationOnly}
                    page={page} />
                <ReferralList
                    currentCursor={currentCursor}
                    page={page}
                    filter={filter}
                    sortBy={sortBy}
                    dispatch={dispatch}
                    selectedReferral={selectedReferral}
                    referrals={referrals}
                    offerConversationOnly={offerConversationOnly}
                />
                <ReferralDetailModal showModal={showDetailModal} referral={selectedReferral} dispatch={dispatch} />
                <MatchOffersModal
                    showModal={showMatchModal}
                    dispatch={dispatch}
                    selectedOfferGuids={selectedOfferGuids}
                />
            </div>
            <ProviderSelectionModal 
                visible={showProviderSelectionModal} 
                onClose={() => {setShowProviderSelectionModal(false)}} 
                onSubmitCallback={() => {
                    history.push(`/${ApplicationRootUrl.AZURE_INTERNAL_CP_PROVIDER_ROUTE_NAME}`)
                }}
            />
        </div>
    );
}
